import { render, staticRenderFns } from "./CreateBases.vue?vue&type=template&id=276cc02c&"
import script from "./CreateBases.vue?vue&type=script&lang=js&"
export * from "./CreateBases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports